export default __webpack_public_path__ + "static/media/foto_comprovante.9fc5a79a.png";